import { ErrorTypes } from "actions/types";

export function serverError(payload) {
  return {
    type: ErrorTypes.SERVER_ERROR,
    payload,
  };
}

export function confirmError(payload) {
  return {
    type: ErrorTypes.CONFIRM_ERROR,
    payload,
  };
}
